module.exports = __webpack_public_path__ + "media/images/balance-planet-energy-43a0299305796235904448f7e17717f9.png";